<template>
  <el-card class="box-card contaier">
    <div class="header">
      <i class="el-icon-arrow-left" @click="goBack()"></i>
      <span class="name">{{ name }}</span>
      <span class="companyName">{{ companyNameC }}</span>
    </div>
    <div class="content" ref="content">
      <div class="firstTime">{{ firstTime }}</div>
      <div v-for="(item, index) in messageLists" :key="index" class="item">
        <div v-if="item.sendType === 1" class="sendType1">
          <!-- 展商发给观众的 1-->
          <span class="content1" v-html="item.content">{{ item.content }}</span>
          <span class="img1">
            <!-- {{ name }} -->
            <img :src="baseUrl + zsInfo.comCover" alt="" />
          </span>
        </div>
        <div v-else class="sendType2">
          <!-- 观众发给展商的 0 -->
          <span class="img2">
            <!-- <img :src="baseUrl + zsInfo.avatarCN" alt="" /> -->
            <span>{{ iconText }}</span>
          </span>
          <span class="content2" v-html="item.content">{{ item.content }}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <tinymce id="myedit" ref="sendMessage" class="tinymce" :data="data"></tinymce>
      <div class="button" @click="send()"> {{$t('minMessage.send')}}</div>
    </div>
  </el-card>
</template>
<script>
import { getMessage, getzsMessage, sendMessage } from '../../../../api/message.js';
import { forMat } from '../../../../utils/common.js';
import Tinymce from '../../comment/tinymce1.vue';
export default {
  data() {
    return {
      baseUrl: forMat(),
      sendUserId: this.$route.query.sendUserId,
      receiveUserId: this.$route.query.receiveUserId,
      zsInfo: {
        comCover: '',
      },
      messageLists: [],
      name: '',
      companyNameC: '',
      firstTime: '',
      value: '',
      data: '',
      iconText: '',
    };
  },
  components: {
    Tinymce,
  },
  created() {
    this.getMessages();
    this.getzsInfo();
    const str = localStorage.getItem('name');
    this.name = str;
    this.iconText = str.slice(-1);
    this.companyNameC = localStorage.getItem('companyName');
  },
  mounted() {},
  updated(){
    this.$refs.content.scrollTop = this.$refs.content.scrollHeight
  },
  methods: {
    async send() {
      this.data = this.$refs.sendMessage.getContent();
      const params = {
        content: this.data,
        receiveUserId: this.sendUserId,
        msgType: this.data.includes('img') ? '1' : '0',
      };
      const that = this;
      try {
        const { data } = await sendMessage(params);
        if (data.code === 200) {
          this.getMessages();
          this.data = '';
          // tinyMCE.activeEditor.setContent('请输入');
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    // 获取展商信息
    async getzsInfo() {
      const params = {
        id: this.receiveUserId,
      };
      try {
        const { data } = await getzsMessage(params);
        if (data.code === 200) {
          this.zsInfo = data.data;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    // 获取聊天记录
    async getMessages() {
      const params = {
        sendUserId: this.sendUserId,
        receiveUserId: this.receiveUserId,
      };
      try {
        const { data } = await getMessage(params);
        if (data.code === 200) {
          // tinyMCE.activeEditor.setContent('请输入');
          if (data.data.length < 1) {
            // 需要默认发送一条消息
            this.send('你好');
          } else {
            this.messageLists = data.data;
            this.firstTime = this.messageLists[0].time;
            console.log(data.data);
          }
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-card {
  height: 966px;
  .header {
    height: 68px;
    border-bottom: 1px solid #e8e8e8;
    padding: 17px 30px;
    box-sizing: border-box;
    line-height: 68px;
    display: flex;
    cursor: pointer;
    i {
      line-height: 32px;
      margin-right: 10px;
    }
    .name {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 33px;
    }
    .companyName {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-left: 20px;
      line-height: 33px;
    }
  }
  .content {
    height: 650px;
    overflow: auto;
    padding-top: 40px;
    padding-bottom: 40px;
    box-sizing: border-box;
    position: relative;
    .firstTime {
      text-align: center;
    }
    .item {
      margin-top: 10px;
      margin-right: 10px;
      overflow: hidden;
      .sendType1 {
        float: right;
        display: flex;

        .img1 {
          width: 40px;
          height: 40px;
          margin-left: 10px;
          border: 1px solid #e0e0e0;
          border-radius: 20px;
          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
          }
        }
        .content1 {
          padding: 10px 20px;
          box-sizing: border-box;
          background: #fdd000;
          position: relative;
          p {
            img {
              width: 200px !important;
              height: 200px !important;
            }
          }
        }
        .content1::after {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          right: -10px;
          top: 10px;
          border: 5px solid;
          border-color: transparent transparent transparent #fdd000;
        }
      }
      .sendType2 {
        float: left;
        display: flex;
        .img2 {
          width: 40px;
          height: 40px;
          margin-right: 10px;
          background: #006fb8;
          text-align: center;
          line-height: 40px;
          border-radius: 20px;
          color: #fff;
        }
        .content2 {
          padding: 10px 20px;
          box-sizing: border-box;
          background: #f1f1f1;
          position: relative;
        }
        .content2::before {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          left: -10px;
          top: 10px;
          border: 5px solid;
          border-color: transparent #f1f1f1 transparent transparent;
        }
      }
    }
  }
  .footer {
    height: 214px;
    background: #f7f7f7;
    border-radius: 2px;
    position: relative;
    .tinymce {
      width: 100%;
      height: 214px;
      background: #f7f7f7;
      border-radius: 2px;
    }
    .button {
      position: absolute;
      bottom: 20px;
      right: 30px;
      width: 88px;
      height: 32px;
      background: #006fb8;
      opacity: 0.5;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
    }
  }
}
</style>
<style scoped>
.tinymce {
  background: #f7f7f7;
  border-radius: 2px;
}
.tinymce >>> .tox-statusbar {
  display: none;
}
.tinymce >>> .tox-toolbar__primary {
  border: 0;
  background: #f7f7f7;
}
.tinymce >>> .tox-edit-area {
  border: 0;
}
.tinymce >>> .tox-edit-area__iframe {
  background: #f7f7f7 !important;
}
.tinymce >>> .tox-tinymce {
  border: 0;
}
.content1 >>> img {
  width: 200px;
  height: 200px;
}
.content2 >>> img {
  width: 200px;
  height: 200px;
}
</style>
